import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';

class FreeTextAutoComplete extends Component {
  onChange = (e, newValue) => {
    const { onChange } = this.props;
    if (typeof newValue === 'string') {
      onChange({ title: newValue });
      return;
    }

    if (newValue && newValue.inputValue) {
      // Create a new value from the user input
      onChange({
        title: newValue.inputValue,
      });
      return;
    }

    onChange(newValue);
  }

  get filter() {
    return createFilterOptions();
  }

  getFilterOptions = (options, params) => {
    const filtered = this.filter(options, params);

    // Suggest the creation of a new value
    if (params.inputValue !== '') {
      filtered.push({
        inputValue: params.inputValue,
        title: `Add "${params.inputValue}"`,
      });
    }

    return filtered;
  }

  getOptionLabel = (option) => {
    // Value selected with enter, right from the input
    if (typeof option === 'string') {
      return option;
    }
    // Add "xxx" option created dynamically
    if (option.inputValue) {
      return option.inputValue;
    }
    // Regular option
    return option.title || '';
  }

  renderInput = (params) => {
    const { label, textFieldType } = this.props;
    return (
      <TextField
        {...params}
        autoComplete="off"
        label={label}
        type={textFieldType || 'text'}
      />
    );
  }

  render() {
    const { value, items } = this.props;

    return (
      <Autocomplete
        value={value}
        onChange={this.onChange}
        filterOptions={this.getFilterOptions}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={items}
        getOptionLabel={this.getOptionLabel}
        renderOption={option => option.title}
        freeSolo
        renderInput={this.renderInput}
        noOptionsText="Keine Einträge verfügbar"
        fullWidth
      />
    );
  }
}

FreeTextAutoComplete.propTypes = {
  label: PropTypes.string,
  items: PropTypes.array,
  value: PropTypes.any,
  textFieldType: PropTypes.string,
  onChange: PropTypes.func,
  isLoading: PropTypes.bool,
};

FreeTextAutoComplete.defaultProps = {
  label: '',
  items: [],
  value: '',
  textFieldType: '',
  isLoading: true,
  onChange: () => {},
};

export default FreeTextAutoComplete;
